(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-glove-hotspots"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fd-glove-hotspots'))customElements.define('fd-glove-hotspots',class extends HTMLElement{
  connectedCallback(){
    this.img=this.querySelector('[data-hotspot-image]');
    this.empty=this.querySelector('[data-hotspot-image-empty]');
    this.mainSrc=this.img&&!this.img.hidden?this.img.src:'';
    this.spots=[...this.querySelectorAll('[data-spot]')];
    this.rows=[...this.querySelectorAll('[data-item]')];
    this.items=this.rows.map(r=>r.querySelector('.fdh-item'));
    const show=src=>{if(!this.img||!src)return;this.img.src=src;this.img.hidden=false;if(this.empty)this.empty.hidden=true;};
    this.open=i=>{
      const already=this.items[i]?.getAttribute('aria-expanded')==='true';
      this.items.forEach((b,j)=>{const on=!already&&j===i;b.setAttribute('aria-expanded',String(on));b.nextElementSibling.hidden=!on;});
      this.spots.forEach(s=>s.setAttribute('aria-expanded',String(!already&&Number(s.dataset.spot)===i)));
      const closeUp=!already&&this.rows[i]?.dataset.closeUp;
      show(closeUp||this.mainSrc);
    };
    // Tapping a spot opens its feature and brings that feature into view (below the sticky photo on phones)
    this.spots.forEach(s=>s.addEventListener('click',()=>{const i=Number(s.dataset.spot);this.open(i);const row=this.rows[i];if(!row)return;const media=this.querySelector('[data-media]');const sticky=getComputedStyle(media).position==='sticky';const below=sticky?media.getBoundingClientRect().bottom:0;const r=row.getBoundingClientRect();if(r.top<below+8||r.bottom>window.innerHeight)window.scrollBy({top:r.top-below-12,behavior:'smooth'});}));
    this.items.forEach((b,i)=>b.addEventListener('click',()=>this.open(i)));
    if(this.items.length)this.open(0);
    // Follow the pattern picked in the buy box
    this.onPattern=e=>{if(!e.detail?.image)return;this.mainSrc=e.detail.image;const openRow=this.rows.find(r=>r.querySelector('.fdh-item[aria-expanded=true]'));if(!openRow||!openRow.dataset.closeUp)show(this.mainSrc);};
    document.addEventListener('fd:pattern-change',this.onPattern);
    // Sticky photo sits under a sticky header
    this.setTop=()=>{const h=document.querySelector('.site-header,header.site-header,[data-section-type="header"]');let top=0;if(h){const p=getComputedStyle(h).position;if(p==='sticky'||p==='fixed')top=Math.round(h.getBoundingClientRect().height);}this.style.setProperty('--fdh-top',top+'px');};
    this.setTop();window.addEventListener('resize',this.setTop);
    // Theme editor: clicking a Feature block opens it
    this.onSelect=e=>{const i=this.rows.findIndex(r=>r.dataset.blockId===e.detail?.blockId);if(i>-1&&this.items[i]?.getAttribute('aria-expanded')!=='true')this.open(i);};
    document.addEventListener('shopify:block:select',this.onSelect);
    // Theme editor only: tap the photo to read the left/top numbers for a spot
    if(window.Shopify&&Shopify.designMode){
      const media=this.querySelector('[data-media]');const tip=document.createElement('div');tip.className='fdh-coords';tip.hidden=true;media.append(tip);
      media.addEventListener('click',e=>{if(e.target.closest('.fdh-spot'))return;const r=media.getBoundingClientRect();const x=Math.round((e.clientX-r.left)/r.width*100),y=Math.round((e.clientY-r.top)/r.height*100);tip.textContent='Left '+x+'  ·  Top '+y;tip.style.left=x+'%';tip.style.top=y+'%';tip.hidden=false;});
    }
  }
  disconnectedCallback(){document.removeEventListener('fd:pattern-change',this.onPattern);document.removeEventListener('shopify:block:select',this.onSelect);window.removeEventListener('resize',this.setTop);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-winter-teaser-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fd-teaser-phrase'))customElements.define('fd-teaser-phrase',class extends HTMLElement{
 connectedCallback(){
  this.phrases=JSON.parse(this.querySelector('[data-phrases]').textContent).filter(Boolean);this.index=0;this.paused=false;
  const hero=this.closest('.fdt-background-hero'),video=hero.querySelector('video');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduced){this.paused=true;video?.pause();}
  
  this.timer=setInterval(()=>{if(this.paused || document.hidden || !this.phrases.length)return;this.index=(this.index+1)%this.phrases.length;this.querySelector('[data-phrase]').textContent=this.phrases[this.index];},Number(this.dataset.seconds)*1000 || 3000);
 }
 disconnectedCallback(){clearInterval(this.timer);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-winter-teaser-signup"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fd-teaser-countdown'))customElements.define('fd-teaser-countdown',class extends HTMLElement{
 connectedCallback(){
  const match=(this.dataset.date||'').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
  if(!match){this.invalid();return;}
  const [y,m,d,h,min]=match.slice(1).map(Number),base=Date.UTC(y,m-1,d,h,min);let target=base;
  if(m<1||m>12||d<1||d>31||h>23||min>59){this.invalid();return;}
  const fmt=new Intl.DateTimeFormat('en-US',{timeZone:'America/Chicago',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
  for(let i=0;i<3;i++){const parts=Object.fromEntries(fmt.formatToParts(new Date(target)).map(p=>[p.type,p.value]));const local=Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day),Number(parts.hour),Number(parts.minute),Number(parts.second));target+=base-local;}
  const check=Object.fromEntries(fmt.formatToParts(new Date(target)).map(p=>[p.type,p.value]));if(Number(check.month)!==m||Number(check.day)!==d||Number(check.hour)!==h||Number(check.minute)!==min){this.invalid();return;}
  const tick=()=>{let n=Math.max(0,Math.floor((target-Date.now())/1000));const values={days:Math.floor(n/86400),hours:Math.floor(n/3600)%24,minutes:Math.floor(n/60)%60,seconds:n%60};for(const [unit,value]of Object.entries(values))this.querySelector('[data-unit="'+unit+'"]').textContent=String(value).padStart(2,'0');if(n===0){clearInterval(this.timer);}};
  this.timer=setInterval(tick,1000);tick();
 }
 invalid(){this.hidden=true;}
 disconnectedCallback(){clearInterval(this.timer);}
});
if(!customElements.get('fd-teaser-email'))customElements.define('fd-teaser-email',class extends HTMLElement{
 connectedCallback(){this.form=this.querySelector('form');this.handler=async(e)=>{e.preventDefault();if(!this.form.reportValidity())return;const status=this.querySelector('[role="status"]'),button=this.querySelector('button'),input=this.querySelector('input');if(button.disabled)return;if(!/^[A-Za-z0-9]{6}$/.test(this.dataset.key)||!/^[A-Za-z0-9]{6}$/.test(this.dataset.list)){status.textContent='Signup is not available yet. Please try again later.';return;}button.disabled=true;status.textContent='Submitting…';const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);try{const response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(this.dataset.key),{method:'POST',headers:{'Content-Type':'application/vnd.api+json','Accept':'application/vnd.api+json','revision':'2026-07-15'},signal:controller.signal,body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Winter Gloves Teaser',profile:{data:{type:'profile',attributes:{email:input.value.trim(),subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:this.dataset.list}}}}})});if(!response.ok)throw Error('request failed');const done=document.createElement('div');done.className='fdt-success';done.setAttribute('role','status');done.tabIndex=-1;const mark=document.createElement('span');mark.className='fdt-success-check';mark.setAttribute('aria-hidden','true');mark.textContent='\u2713';const head=document.createElement('strong');head.textContent=this.dataset.successHeading||'You\u2019re in!';const msg=document.createElement('p');msg.textContent=this.dataset.success;done.append(mark,head,msg);this.form.replaceWith(done);done.focus({preventScroll:true});done.scrollIntoView({block:'center',behavior:'smooth'});}catch(error){status.textContent='We couldn’t complete your signup. Please try again.';button.disabled=false;}finally{clearTimeout(timeout);}};this.form.addEventListener('submit',this.handler);}
 disconnectedCallback(){this.form?.removeEventListener('submit',this.handler);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
